<template>
    <div class="main-social-links" :class="$mq">
        <a
            v-if="data.email"
            class="social-link"
            :href="`mailto:${data.email}?subject=Contacting From Website`"
        >
            <fa-icon :icon="['fas', 'envelope']" aria-label="email" />
        </a>
        <a
            v-if="data.instagram"
            class="social-link"
            :href="data.instagram"
            target="_blank"
            rel="noopener"
        >
            <fa-icon :icon="['fab', 'instagram']" aria-label="instagram" />
        </a>
        <a
            v-if="data.facebook"
            class="social-link"
            :href="data.facebook"
            target="_blank"
            rel="noopener"
        >
            <fa-icon :icon="['fab', 'facebook-f']" aria-label="facebook" />
        </a>
        <a
            v-if="data.twitter"
            class="social-link"
            :href="data.twitter"
            target="_blank"
            rel="noopener"
        >
            <fa-icon :icon="['fab', 'twitter']" aria-label="twitter" />
        </a>
        <a
            v-if="data.linkedin"
            class="social-link"
            :href="data.linkedin"
            target="_blank"
            rel="noopener"
        >
            <fa-icon :icon="['fab', 'linkedin-in']" aria-label="linkedin" />
        </a>
    </div>
</template>

<script>
    // CMS DATA LOADING
    import dataLoader from '../../mixins/dataLoader';
    import data from '../../content/components/social-links.md';

    export default {
        name: 'main-social-links',

        mixins: [dataLoader(data)],
    };
</script>

<style lang="scss" scoped>
    .main-social-links {
        position: fixed;
        left: 0;
        top: 65vh;
        transform: translateY(-50%);
        z-index: 10;

        .social-link {
            display: flex;
            align-items: center;
            justify-content: center;
            background: $purple;
            color: #fff;
            font-size: 25px;
            height: 50px;
            width: 50px;
            box-shadow: 2px 2px 5px 0px rgba(#000, 0.2);

            &:not(:last-of-type) {
                margin-bottom: 10px;
            }

            &:hover {
                background: darken($purple, 5%);
            }
        }

        &.tablet {
            .social-link {
                height: 40px;
                width: 40px;
                font-size: 20px;

                &:not(:last-of-type) {
                    margin-bottom: 7px;
                }
            }
        }

        &.mobile {
            .social-link {
                height: 35px;
                width: 35px;
                font-size: 18px;

                &:not(:last-of-type) {
                    margin-bottom: 7px;
                }
            }
        }
    }
</style>
